module.exports = __webpack_public_path__ + "static/img/1_1_2_1.25c87e27.jpg";